/* eslint-disable */
import { action } from 'app/actions';
/* eslint-enable */
export const GET_PLANS = 'plans-planner/GET_PLANS';
export const GET_PLANNER = 'plans-planner/GET_PLANNER';

export const getPlans = payload => action(GET_PLANS, { payload });
export const getPlanner = payload => action(GET_PLANNER, { payload });
